import { addItem } from "Redux/Slices/BreadCrumb";
import { _routes } from "SuperAdmin/Routes/routes";
import { getRoleInformationById, updateRole } from "SuperAdmin/Services/Role";
import { handleAPIResponse } from "SuperAdmin/Utils/HandleAPIResponse";
import { Form, message } from "antd";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import FormUpdate from "./Form/Form";
import styles from "./RoleDetail.module.scss";
const RoleDetail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const role_id = window.location.pathname.split("/")[3];
  const [isLoading, setIsLoading] = useState(true);
  const [initValues, setInitValues] = useState({});
  const [form] = Form.useForm();
  const type = Form.useWatch("type", form);
  const unitPermission = Form.useWatch("unit_permissions", form);
  const facultyProfilePermission = Form.useWatch(
    "faculty_profile_permission",
    form
  );
  const [institution, setInstitution] = useState(null);
  useEffect(() => {
    setIsLoading(true);
    getRoleInformationById(role_id, (res) => {
      handleAPIResponse(res, () => {
        dispatch(
          addItem({
            key: res.data.management_scope_name,
            label: res.data.management_scope_name,
            to: `/roles/${role_id}`,
            name: res.data.name,
            level: _routes[4].level,
          })
        );

        const facultyList = res.data.permissions.filter(
          (item) => item.split("_")[1] === "FACULTY"
        );
        const unitList = res.data.permissions.filter(
          (item) => item.split("_")[1] === "UNIT"
        );
        setInitValues({
          name: res.data.name,
          permissions: [...facultyList, ...unitList],
        });
        form.setFieldsValue({
          unit_permissions: unitList,
          faculty_profile_permission: facultyList,
          management_scope_id: res.data.management_scope_id,
          management_scope_name: res.data.management_scope_name,
          level: res.data.level,
          type: res.data.type,
          institution_id: res.data.institution_id,
          institution_name: res.data.institution_name,
          name: res.data.name,
        });
        setIsLoading(false);
      });
    });
  }, []);
  const onFinishForm = () => {
    const payload = {
      permissions: [...facultyProfilePermission, ...unitPermission],
      name: form.getFieldValue().name,
    };
    const changedValues = Object.keys(payload).reduce((acc, key) => {
      const initialValue = initValues[key];
      const currentValue = payload[key];
      if (
        Array.isArray(initialValue) &&
        !_.isEqual(initialValue, currentValue)
      ) {
        acc[key] = currentValue;
      } else if (
        !Array.isArray(initialValue) &&
        initialValue !== currentValue
      ) {
        acc[key] = currentValue;
      }
      return acc;
    }, {});
    updateRole(role_id, changedValues, (res) => {
      if (res.status) {
        setTimeout(() => {
          message.success("Update role successfully");
        }, 1500);
        navigate("/super-admin/roles");
      }
    });
  };
  return (
    <div className={styles["role-detail"]}>
      <FormUpdate
        form={form}
        type={type}
        onFinishForm={onFinishForm}
        isLoading={isLoading}
      />
    </div>
  );
};

export default RoleDetail;
